module.exports = __webpack_public_path__ + "img/banner2.1f3d9152.png";